module.exports = __webpack_public_path__ + "48ccf9a0ee0a5335b5e6843575e6e6b9.png";